<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import { fetchPolicy, createPolicy, updatePolicy } from '@apis/admin/affiliate'
import LangItem from '@components/admin/lang-input'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import PolicyCauserCondition from '@components/admin/affiliate-policy-causer-condition'
import PolicyActionCondition from '@components/admin/affiliate-policy-action-condition'
import PolicyBeneficiary from '@components/admin/affiliate-policy-beneficiary'

export default {
  components: {
    LangItem,
    PolicyCauserCondition,
    PolicyActionCondition,
    PolicyBeneficiary,
  },
  props: {
    policy_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      info: null,
      loading: false,
      active_tab: 'info',
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadPolicy()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadPolicy() {
      const { policy_info } = await fetchPolicy(this.policy_seq)
      this.params = defaults(policy_info, {
        target_action: null,
        title: '',
        list_order: 0,
        is_global: 'N',
        seq: null,
        regdate: null,
      })
      this.info = policy_info
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updatePolicy : createPolicy
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('affiliate_policy_info.msg_allowance_policy_modify')
        : this.$t('affiliate_policy_info.msg_allowance_policy_register')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <el-tabs v-model="active_tab" :stretch="true">
    <el-tab-pane :label="$t('admin.default_info')" name="info">
      <form
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleSubmit"
      >
        <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row"
                ><div>{{ $t('affiliate_policy_info.title') }}</div></th
              >
              <td
                ><LangItem v-if="!loading" v-model="params.title"></LangItem
              ></td>
              <th scope="row"
                ><div>{{
                  $t('affiliate_policy_info.global_coverage')
                }}</div></th
              >
              <td>
                <select v-model="params.is_global">
                  <option value="N">{{
                    $t('affiliate_policy_info.apply_no')
                  }}</option>
                  <option value="Y">{{
                    $t('affiliate_policy_info.apply_ok')
                  }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th scope="row"
                ><div>{{ $t('affiliate_policy_info.target_action') }}</div></th
              >
              <td>
                <select v-model="params.target_action">
                  <option :value="null">{{
                    $t('affiliate_policy_info.select')
                  }}</option>
                  <option
                    v-for="val in constants.affiliate.policy.target_action"
                    :key="val[0]"
                    :value="val[0]"
                    >{{ val[1] }}</option
                  >
                </select>
              </td>
              <th scope="row"
                ><div>{{ $t('affiliate_policy_info.output_order') }}</div></th
              >
              <td
                ><input
                  v-model="params.list_order"
                  type="text"
                  :class="[$style.inputTypeText, $style.w40, $style.tRight]"
              /></td>
            </tr>
            <tr>
              <th colspan="4" :class="$style.button">
                <span :class="[$style.button, $style.black]"
                  ><input
                    type="submit"
                    :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
                /></span>
              </th>
            </tr>
          </tbody>
        </table>
      </form>
    </el-tab-pane>
    <el-tab-pane
      :disabled="!info || !info.seq"
      :label="$t('affiliate_policy_info.causer_condition')"
      name="CAUSER_CONDITION"
    >
      <PolicyCauserCondition
        v-if="info && info.seq"
        :policy_seq="info.seq"
      ></PolicyCauserCondition>
    </el-tab-pane>
    <el-tab-pane
      :disabled="!info || !info.seq"
      :label="$t('affiliate_policy_info.action_condition')"
      name="ACTION_CONDITION"
    >
      <PolicyActionCondition
        v-if="info && info.seq"
        :policy_seq="info.seq"
      ></PolicyActionCondition>
    </el-tab-pane>
    <el-tab-pane
      :disabled="!info || !info.seq"
      :label="$t('affiliate_policy_info.beneficiary')"
      name="BENEFICIARY"
    >
      <PolicyBeneficiary
        v-if="info && info.seq"
        :policy_seq="info.seq"
      ></PolicyBeneficiary>
    </el-tab-pane>
  </el-tabs>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
